import React from 'react';
import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { useAuth } from '../context/AuthContext';

export default function Footer() {
  const { isAuthenticated, user } = useAuth();
  const { t } = useTranslation('common');

  // Show fixed bottom bar when user is authenticated
  if (isAuthenticated && user) {
    return (
      <footer
        className="fixed bottom-0 left-0 right-0 h-5 shadow-lg rounded-t-3xl z-30"
        style={{ backgroundColor: '#162917' }}
      >
        {/* Draggable Handle */}
        <div className="flex justify-center py-2 border-b border-outline/20 cursor-grab">
          <div className="w-12 h-1 bg-on-background/20 rounded-full"></div>
        </div>
      </footer>
    );
  }

  return (
    <footer className="bg-primary text-on-primary py-16">
      <div className="max-w-container-max mx-auto px-margin-mobile">
        <div className="grid grid-cols-1 md:grid-cols-3 gap-8 mb-12">
          <div>
            <h3 className="text-headline-md font-bold mb-4">WELLIS</h3>
            <p className="text-body-md opacity-80">{t('footer.tagline')}</p>
          </div>

          <div>
            <h4 className="text-label-md font-bold uppercase mb-4">{t('footer.company')}</h4>
            <ul className="space-y-2">
              <li><Link to="/products" className="text-body-md opacity-80 hover:opacity-100">{t('footer.products')}</Link></li>
              <li><Link to="/marketing-plan" className="text-body-md opacity-80 hover:opacity-100">{t('nav.marketingPlan')}</Link></li>
              <li><Link to="/about" className="text-body-md opacity-80 hover:opacity-100">{t('footer.about')}</Link></li>
              <li><Link to="/contact" className="text-body-md opacity-80 hover:opacity-100">{t('footer.contact')}</Link></li>
              <li><button className="text-body-md opacity-80 hover:opacity-100 bg-none border-none p-0 cursor-pointer">{t('footer.privacy')}</button></li>
            </ul>
          </div>

          <div>
            <h4 className="text-label-md font-bold uppercase mb-4">{t('footer.contact')}</h4>
            <p className="text-body-md opacity-80">{t('footer.contactEmail')}</p>
          </div>
        </div>

        <div className="border-t border-outline-variant/20 pt-8 flex flex-col md:flex-row justify-between items-center">
          <p className="text-body-sm opacity-60">{t('footer.copyright')}</p>
          <div className="flex gap-6 mt-4 md:mt-0">
            <a href="https://linkedin.com" target="_blank" rel="noopener noreferrer" className="text-body-md opacity-80 hover:opacity-100">{t('footer.linkedin')}</a>
            <a href="https://instagram.com" target="_blank" rel="noopener noreferrer" className="text-body-md opacity-80 hover:opacity-100">{t('footer.instagram')}</a>
            <a href="https://twitter.com" target="_blank" rel="noopener noreferrer" className="text-body-md opacity-80 hover:opacity-100">{t('footer.twitter')}</a>
          </div>
        </div>
      </div>
    </footer>
  );
}
